import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { setContext } from "@apollo/client/link/context"
import { onError } from '@apollo/client/link/error'
import { useAuth } from '../store/useAuth'

const resetToken = onError(({ graphQLErrors, networkError }) => {
  const auth = useAuth();
  const isNetwork401 = networkError && networkError.statusCode === 401;
  const isGqlUnauth = Array.isArray(graphQLErrors) && graphQLErrors.some(e => e.extensions && (e.extensions.code === 'UNAUTHENTICATED' || e.extensions.http && e.extensions.http.status === 401));
  if (isNetwork401 || isGqlUnauth) {
    auth.refreshToken();
  }
});

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_GRAPHQL_URL || "https://api.tovari-kron.ru/v1/graphql"
});

// 🔥 ИСПРАВЛЕНИЕ: Добавляем possibleTypes
// Теперь Apollo знает, что все эти типы принадлежат интерфейсу Category
const cache = new InMemoryCache({
  possibleTypes: {
    Category: [
      'BranchCategory',
      'LeafCategory',
      'NonRootBranchCategory',
      'NonRootCategory',
      'NonRootLeafCategory',
      'RootBranchCategory',
      'RootCategory',
      'RootLeafCategory'
    ],
  }
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  const nextHeaders = { ...headers };
  if (token) {
    nextHeaders.authorization = token;
  }
  return { headers: nextHeaders };
});

const authFlowLink = authLink.concat(resetToken);
const link = authFlowLink.concat(httpLink);

// Create the apollo client
const apolloClient = new ApolloClient({
  link,
  cache,
})

export default apolloClient;
